module.exports = __webpack_public_path__ + "static/media/ks_shack_charles_nye_tablet.3ba8bc6a.png";